import { DialogProgrammatic } from 'buefy'

const Confirm = {
    show: ({
        message = "Desea continuar",
        cancelText = "Cancelar",
        confirmText = "Continuar",
        action
    }) => {
        DialogProgrammatic.confirm({
            title: "Confirmar",
            type: 'is-success',
            size: "is-small",
            message,
            cancelText,
            confirmText,
            onConfirm: action
        })
    }
}

export default Confirm